<template>
    <div v-if="list.length > 0">
        <h5 class="text-primary text-uppercase">offerte speciali</h5>
        <h2 class="mb-4">L'occasione che stavi aspettando</h2>
        <div v-for="(item, index) in list" :key="index" class="mb-3" ref="listRef">
            <HorizontalItemTourMobile v-if="isMobile" :disabled="true" :aereoporti="aereoporti" :value="item" @select="onSelect" :isHomePage="true"/>
            <HorizontalItemTour v-else :disabled="true" :aereoporti="aereoporti" :value="item" @select="onSelect" :isHomePage="true"/>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import HorizontalItemTour from '../../common/tours/HorizontalItemTour'
import HorizontalItemTourMobile from '../../../mobile/widgets/common/tours/HorizontalItemTour'
import TourAccompagnatiSearcher from '../../../searcher/TourAccompagnatiSearcher'
import MobileDetector from '../../../common/MobileDetector'

export default {
  name: 'OfferteSpeciali',
  mixins: [TourAccompagnatiSearcher, MobileDetector],
  components: {HorizontalItemTour, HorizontalItemTourMobile},
  computed: {
    list () {
      return this.getTourList().filter(tour => {
        const offerteSpeciali = this.getToursOfferteSpeciali()
        const config = offerteSpeciali.list.find(item => {
          return item.codice === tour.detailResponse.detail.productID
        })
        const escort = tour.detailResponse.detail.escort
        return config && escort != null
      })
    },
    aereoporti () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    }
  },
  methods: {
    ...mapGetters(['getToursOfferteSpeciali', 'getTourList', 'getTypesAereoporti']),
    onSelect (tour) {
      this.searchAllTourAccompagnati(tour)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/home/OfferteSpeciali.vue